export default __webpack_public_path__ + "static/meshery-adapter-library-overview-76d1e59ec8b0d62f377384ea95f9d0cf.webp";